'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('./colors');

/*
 * Shake
 */
var shake = {
  '20%': { transform: 'scale3d(1.1, 1.1, 1)' },
  '40%': { transform: 'scale3d(.94, .94, 1)' },
  '60%': { transform: 'scale3d(1.04, 1.04, 1)' },
  '80%': { transform: 'scale3d(.98, .98, 1)' }
}; /*
    * Local Import
    */


var shakeBig = {
  '20%': { transform: 'scale3d(2, 2, 1)' },
  '40%': { transform: 'scale3d(.8, .8, 1)' },
  '60%': { transform: 'scale3d(1.4, 1.4, 1)' },
  '80%': { transform: 'scale3d(.9, .9, 1)' }
};

/*
 * Blink
 */
var blink = {
  '20%': { opacity: 1 },
  '30%': { opacity: 0 },
  '70%': { opacity: 0 },
  '80%': { opacity: 1 }
};

/*
 * FadeIn / FadeOut
 */
var fadeOut = {
  '100%': { opacity: 0 }
};

var fadeIn = {
  '0%': { opacity: 0 }
};

var fadeInTop = {
  '0%': {
    transform: 'translate3d(0, -1em, 0)',
    opacity: 0
  }
};

var fadeOutTop = {
  '100%': {
    transform: 'translate3d(0, -1em, 0)',
    opacity: 0
  }
};

var fadeInRight = {
  '0%': {
    transform: 'translate3d(1em, 0, 0)',
    opacity: 0
  }
};

var fadeOutRight = {
  '100%': {
    transform: 'translate3d(1em, 0, 0)',
    opacity: 0
  }
};

var fadeInBottom = {
  '0%': {
    transform: 'translate3d(0, 1em, 0)',
    opacity: 0
  }
};

var fadeOutBottom = {
  '100%': {
    transform: 'translate3d(0, 1em, 0)',
    opacity: 0
  }
};

var fadeInLeft = {
  '0%': {
    transform: 'translate3d(-1em, 0, 0)',
    opacity: 0
  }
};

var fadeOutLeft = {
  '100%': {
    transform: 'translate3d(-1em, 0, 0)',
    opacity: 0
  }
};

var fadeScaleIn = {
  '0%': {
    opacity: 0,
    transform: 'scale3d(.95, .95, 1)'
  }
};

/*
 * Pop In / Pop Out
 */
var popIn = {
  '0%': { transform: 'scale3d(0, 0, 1)' },
  '80%': { transform: 'scale3d(1.1, 1.1, 1)' }
};

var popOut = {
  '20%': { transform: 'scale3d(1.2, 1.2, 1)' },
  '100%': { transform: 'scale3d(0, 0, 1)' }
};

var popInBig = {
  '0%': { fontSize: 0 },
  '8%': { fontSize: '1.6em' },
  '10%': { fontSize: '1.5em' },
  '100%': { fontSize: '1.5em' }
};

/*
 * Slide Down
 */
var slideDown = {
  '0%': { transform: 'translateY(-100%)' },
  '10%': { transform: 'translateY(0px)' },
  '90%': { transform: 'translateY(0px)' },
  '100%': { transform: 'translateY(-100%)' }
};

/*
 * Back And Forth
 */
var backAndForth = {
  '50%': { transform: 'translateX(.1em)' }
};

/*
 * Overlay Background
 */
var overlayBg = {
  '100%': {
    background: 'rgba(' + _colors.colorsRGB.black + ', 0.8)'
  }
};

/*
 * Rotate
 */
var pivotIn = {
  '100%': { transform: 'rotate(20deg)' }
};

var pivotOut = {
  '0%': { transform: 'rotate(20deg)' }
};

var spin = {
  '100%': { transform: 'rotate(1turn)' }
};

/*
 * Multicolors
 */
var colors = function colors(arrayColors) {
  return arrayColors.reduce(function (result, color, index) {
    result[index * 100 / 6 + '%'] = { background: color };
    return result;
  }, {});
};

/*
 * Progress
 */
var progress = {
  '100%': {
    transform: 'translateX(100%)'
  }
};

/*
 * Bounce
 */
var bounce = {
  '50%': {
    transform: 'translate3d(0, -2em, 0)'
  }
};

/*
 * Export
 */
exports.default = {
  shake: shake,
  shakeBig: shakeBig,
  blink: blink,
  fadeOut: fadeOut,
  fadeIn: fadeIn,
  fadeInTop: fadeInTop,
  fadeOutTop: fadeOutTop,
  fadeInRight: fadeInRight,
  fadeOutRight: fadeOutRight,
  fadeInBottom: fadeInBottom,
  fadeOutBottom: fadeOutBottom,
  fadeInLeft: fadeInLeft,
  fadeOutLeft: fadeOutLeft,
  fadeScaleIn: fadeScaleIn,
  popIn: popIn,
  popOut: popOut,
  popInBig: popInBig,
  slideDown: slideDown,
  backAndForth: backAndForth,
  overlayBg: overlayBg,
  pivotIn: pivotIn,
  pivotOut: pivotOut,
  spin: spin,
  colors: colors,
  progress: progress,
  bounce: bounce
};